import React from "react";

const PublicHeader = () => {
  return (
    <nav className="bg-white border-gray-200 px-2 sm:px-4 py-6 dark:bg-gray-800">
      <div className="flex flex-wrap justify-between items-center mx-auto">
        <a href="/" className="flex items-center">
          <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white">
            Annapurna
          </span>
        </a>
      </div>
    </nav>
  );
};

export default PublicHeader;
